/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function TextAlignJustify(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" />
        <Path d="M216,100H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" />
        <Path d="M216,140H40.00586a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Z" />
        <Path d="M216,180H40.00586a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Z" />
      </G>
    </Svg>
  );
}

export default TextAlignJustify;
